import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// ui components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

// icons
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Tooltip from "@material-ui/core/Tooltip";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { UsePutApi } from "beaktShared/services/crudeApiService";
import {MaskCel} from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function ContatoEstabelecimento({item, CallHandleVoltar, CallUpdateItem}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
        show:true,
        color:color,
        message:message      
      });
      setTimeout(function() {
        setNotification({show:false});
      }, 8000);       
  };

  const { register, handleSubmit, setValue, errors, getValues, setError, clearError } = useForm({mode: "onChange"}); 
  const [loading, setLoading] = React.useState(false);
  const [contatosadicionais, setcontatosadicionais] = React.useState([]);

  useEffect(() => {
    if(!item.estabelecimentoId)
        return;       

    setValue('estabelecimentoId', item.estabelecimentoId);
    if(item.estabelecimentoContatoAdicionais) 
    {
      if(item.estabelecimentoContatoAdicionais.length > 0)
        setcontatosadicionais(item.estabelecimentoContatoAdicionais)
    }

  }, [item]);

  const handleClickaddContato = () =>{
    
    let data = getValues();
    
    if(data.nome === "")
    {
      setError("nome","required")
      return false;
    }
    else
      clearError("nome")
    
    if(data.celular === "" && data.email ==="")
    {
      showNotification(t('information_message.enter_a_cell_phone_or_email_for_additional_contact'),'danger');
      return false;
    }

    let objAdd = {
      estabelecimentoId: parseInt(data.estabelecimentoId),
      estabelecimentoContatoAdicionalId: (contatosadicionais.length + 1),
      nome: data.nome,      
      celular: data.celular,  
      email: data.email,
    }
    let lstUpdate = [
      ...contatosadicionais,
      objAdd
    ]
    setValue("nome","");
    setValue("email","");
    setValue("celular","");
    setcontatosadicionais(lstUpdate);
  }

  const handleClickremoveContato = (estabelecimentoContatoAdicionalId) =>{
    var listFiltered = contatosadicionais.filter(obj => {
        return obj.estabelecimentoContatoAdicionalId !== estabelecimentoContatoAdicionalId; 
    });
    setcontatosadicionais(listFiltered);    
  }

  const onSubmit = (data, e) => {   
    e.preventDefault();
    setLoading(true);  
    
    if(!item.estabelecimentoId)
    {
      showNotification(t('information_message.fill_in_the_details_of_the_establishment_and_then_inform_additional_contacts'),'danger');
      setLoading(false);  
      return false;
    }

    if(contatosadicionais.length === 0)
    {
      showNotification(t('information_message.insert_at_least_1_additional_contact'),'danger');
      setLoading(false);  
      return false;
    }
    
    let estabelecimento = {
      ...item,
      estabelecimentoContatoAdicionais: contatosadicionais
    }

    setLoading(true);
    let endPoint = `estabelecimentos/atualizacontatosadicionais/${estabelecimento.estabelecimentoId}/`
    UsePutApi(endPoint, session.id, estabelecimento).then(result=>{      
      if(result.status !== 200)
      {                                    
        showNotification(result.message,'danger');
        setLoading(false);
        return false; 
      } 
      CallUpdateItem(result.data);
      showNotification(result.message,'success');
      setLoading(false);
      return true;                 
    }); 

  }
 
  return (
    <div style={{width:'100%',padding:'20px'}}>
    <form onSubmit={handleSubmit(onSubmit)}>
      
      <input style={{display:'none'}} defaultValue={0} name="estabelecimentoId" ref={register} />
    
      <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo"> 
          <h6>{t('accreditation.additional_contact_information')} </h6>
         </div>
        </GridItem>
        <GridItem xs={12} sm={8} md={8}>
          <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.nome?true:false}
                label={t('label.name')+" *"}
                variant="outlined"
                inputRef={register({ required: false })}
                name="nome"
                InputLabelProps={{shrink: true}}                                   
                inputProps={{maxLength: 150}}
            /> 
            {errors.nome &&
            <FormHelperText className={classes.labelRootError}>
                <span>{t('label.required')} </span>
            </FormHelperText>}
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <FormControl fullWidth className={classes.formControl}>
          <TextField
              error={errors.celular?true:false}
              label={t('label.cell_phone')}
              variant="outlined"
              inputRef={register({required: false})}
              name="celular"
              InputLabelProps={{shrink: true}}   
              InputProps={{maxLength: 10, inputComponent: MaskCel }}  
          />
          </FormControl>
      </GridItem> 
        <GridItem xs={12} sm={8} md={8}>
          <FormControl fullWidth className={classes.formControl}>
          <TextField
              error={errors.email?true:false}
              label={t('label.email')}
              variant="outlined"
              name="email"
              InputLabelProps={{shrink: true}}
              InputProps={{maxLength: 50 }}  
              inputRef={register({
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: t('label.invalid_email')
                }
              })}
          />
          {errors.email && 
          <FormHelperText className={classes.labelRootError}>
                <span>{errors.email.message}</span>
           </FormHelperText>}
          </FormControl>
      </GridItem>       
      <GridItem xs={12} sm={4} md={4}>
          <Button onClick={e => { handleClickaddContato()}}  round color="primary" >
              {t('label.add')}
          </Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          
        {contatosadicionais.length > 0 && 
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>{t('label.name')} </th>
                <th>{t('label.cell_phone')}</th>
                <th>{t('label.email')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {contatosadicionais.map(item => (  
                  <tr key={item.estabelecimentoContatoAdicionalId}>
                    <td>{ item.nome }</td>
                    <td>{ item.celular }</td>
                    <td>{ item.email }</td>
                    <td style={{padding:'0px',width:'30px'}}>                  
                    <div className="actions-right">
                    <Button onClick={e => { handleClickremoveContato(item.estabelecimentoContatoAdicionalId)}} justIcon round simple color="danger" className="remove" >
                      <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                        <Close />
                      </Tooltip>
                    </Button>
                    </div>
                  </td>
                </tr> 
              ))}                        
            </tbody>
          </table>
        }
        </GridItem>
      </GridContainer>
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>  
         <center>  <br/><br/> 
         {notification.show &&
          <SnackbarContent
            message={notification.message}
            color={notification.color}
            closeNotification={() => setNotification({show:false})}
            close
          />}
          <Button onClick={() => CallHandleVoltar()} color="transparent" >
              {t('label.return')}
          </Button>
          <Button type="submit" color="primary" >
              {t('button.to_save')}
              {loading && <div> ...{t('label.loading')} </div>}
          </Button>
          </center>  
        </GridItem>
      </GridContainer>  
    
    </form>
  </div>
  );
}